import React, { useState, useEffect } from 'react'
import "./CSS/Channel.css"
import { connect } from 'react-redux'
import Store from '../Store/Store'
import { add_channel, edit_channel, remove_channel, set_channel_action } from '../Action/Action'

const Channel = (props) => {

  const [alert, Setalert] = useState("")

  const [ucer_id, SetUcer_ID] = useState(() => {
    var _ucer = sessionStorage.getItem("ucer_id");
    var json_ucer;
    if (_ucer) {
      json_ucer = JSON.parse(_ucer);
      json_ucer = Number(json_ucer)
      return json_ucer

    }
  })

  const [inp1, Setinp1] = useState("")
  const [inp2, Setinp2] = useState(0)
  const [inp3, Setinp3] = useState(0)
  const [inp4, Setinp4] = useState(0)
  const [inp5, Setinp5] = useState(0)


  useEffect(() => {
    document.querySelector("section.channel_section").style.zoom = "90%"
  }, [])

  //yetkilendirme
  const [channel_yazma_control, Set_channel_yazma_control] = useState(false);
  const [channel_silme_control, Set_channel_silme_control] = useState(false);


  useEffect(() => {
    if (props.yetkilendirme && props.userId !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.userId];
      if (newObj !== undefined) {
        if (newObj["İletişim"]["Y"] === "t") {

          Set_channel_yazma_control(true)
        } else {
          Set_channel_yazma_control(false)
        }
        if (newObj["İletişim"]["S"] === "t") {

          Set_channel_silme_control(true)
        } else {
          Set_channel_silme_control(false)
        }
      }
    }
  }, [props.yetkilendirme])

  useEffect(() => { console.log(props.channels); }, [props.channels])


  const [edit_id, Set_edit_id] = useState(null)
  const [edit_channel_time, Set_edit_channel_time] = useState(null)
  const [edit_channel_name, Set_edit_channel_name] = useState(null)
  const [edit_channel_length, Set_edit_channel_length] = useState(null)
  const [edit_channel_db_number, Set_edit_channel_db_number] = useState(null)
  const [edit_start, Set_edit_start] = useState(null)

  const onEditFormSubmit = async (e) => {
    e.preventDefault()
    console.log(e.target.parentElement);
    var obj = {
      "channelName": edit_channel_name,
      "channelDbNumber": edit_channel_db_number,
      "channelLength": edit_channel_length,
      "channelTime": edit_channel_time,
      "channelStart": edit_start,
      "channelOpcType": 1,
      "channelType": 1,
      "channelPlcId": 1,
      "channelId": Number(edit_id),
      "companyId": ucer_id
    }

    console.log(obj);

    const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/EditChannel", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json"
      },
      body: JSON.stringify(obj)
    })


    if (request.status === 200) {

      await Store.dispatch(edit_channel(Number(edit_id), obj))

      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_edit");
      alert_box.classList.add("alert-box-active")
      Setalert(`${edit_channel_name} was updated successfully`)

      setTimeout(() => {
        alert_box.classList.remove("alert_edit")
        alert_box.classList.remove("alert-box-active")
        Setalert("")
      }, 4000);



      var pop_up = document.querySelector(".edit_channel_pop_up")
      var channel_seciton = document.querySelector("section.channel_section")
      if (channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.remove("channel_section_dark")

      if (pop_up.classList.contains("edit_channel_pop_up_active")) {
        pop_up.classList.remove("edit_channel_pop_up_active")
      }

    }



  }

  const OnChangeinp1 = (e) => {
    Setinp1(e.target.value)
  }
  const OnChangeinp2 = (e) => {
    Setinp2(Number(e.target.value))
  }
  const OnChangeinp3 = (e) => {
    Setinp3(Number(e.target.value))
  }
  const OnChangeinp4 = (e) => {
    Setinp4(Number(e.target.value))
  }
  const OnChangeinp5 = (e) => {
    Setinp5(Number(e.target.value))
  }


  const OnChangeinp1_1 = (e) => {
    Set_edit_channel_name(e.target.value)
  }
  const OnChangeinp2_2 = (e) => {
    Set_edit_start(Number(e.target.value))
  }
  const OnChangeinp3_3 = (e) => {
    Set_edit_channel_length(Number(e.target.value))
  }
  const OnChangeinp4_4 = (e) => {
    Set_edit_channel_db_number(Number(e.target.value))
  }
  const OnChangeinp5_5 = (e) => {
    Set_edit_channel_time(Number(e.target.value))
  }

  const open_add_pop_up = () => {
    var pop_up = document.querySelector(".add_channel_pop_up")

    var channel_seciton = document.querySelector("section.channel_section")

    if (!channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.add("channel_section_dark")

    if (!pop_up.classList.contains("add_channel_pop_up_active")) {
      pop_up.classList.add("add_channel_pop_up_active")
    }

  }
  const open_edit_pop_up = (e) => {
    Set_edit_id(e.target.parentElement.parentElement.id)
    Set_edit_channel_name(e.target.parentElement.parentElement.firstElementChild.textContent)
    Set_edit_start(Number(e.target.parentElement.parentElement.firstElementChild.nextElementSibling.textContent))
    Set_edit_channel_length(Number(e.target.parentElement.parentElement.firstElementChild.nextElementSibling.nextElementSibling.textContent))
    Set_edit_channel_db_number(Number(e.target.parentElement.parentElement.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.textContent))
    Set_edit_channel_time(Number(e.target.parentElement.parentElement.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.textContent))

    var pop_up = document.querySelector(".edit_channel_pop_up")
    var channel_seciton = document.querySelector("section.channel_section")

    if (!channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.add("channel_section_dark")

    if (!pop_up.classList.contains("edit_channel_pop_up_active")) {
      pop_up.classList.add("edit_channel_pop_up_active")
    }

  }

  const close_add_pop_up = () => {
    Set_edit_id(null)
    Set_edit_channel_name(null)
    Set_edit_channel_length(null)
    Set_edit_channel_db_number(null)
    Set_edit_channel_time(null)
    var pop_up = document.querySelector(".add_channel_pop_up")
    var channel_seciton = document.querySelector("section.channel_section")
    if (channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.remove("channel_section_dark")

    if (pop_up.classList.contains("add_channel_pop_up_active")) {
      pop_up.classList.remove("add_channel_pop_up_active")
    }

  }
  const close_edit_pop_up = () => {
    var pop_up = document.querySelector(".edit_channel_pop_up")
    var channel_seciton = document.querySelector("section.channel_section")
    if (channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.remove("channel_section_dark")

    if (pop_up.classList.contains("edit_channel_pop_up_active")) {
      pop_up.classList.remove("edit_channel_pop_up_active")
    }

  }

  useEffect(() => {
    const componentDidMount = async () => {
      console.log(ucer_id, typeof (ucer_id));
      const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/GetChannelList", {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
          "companyId": String(ucer_id)
        })
      })

      const response = await request.json()

      console.log(response);

      await Store.dispatch(set_channel_action(response))

    }

    componentDidMount()
  }, [])


  const deleteRow = async (e) => {

    var channelId_ = e.target.parentElement.parentElement.id

    channelId_ = Number(channelId_);

    const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/DeleteChannel", {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        "channelId": channelId_,
        "companyId": ucer_id
      })
    })

    if (request.status === 200) {

      await Store.dispatch(remove_channel(Number(channelId_)))

      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_delete");
      alert_box.classList.add("alert-box-active")
      Setalert(`${e.target.parentElement.parentElement.firstElementChild.textContent} was deleted successfully`)

      setTimeout(() => {
        alert_box.classList.remove("alert_delete")
        alert_box.classList.remove("alert-box-active")
        Setalert("")
      }, 4000);
    }

  }

  const OnFormSubmit = async e => {
    e.preventDefault()

    var obj = {
      "channelName": inp1,
      "channelDbNumber": inp4,
      "channelType": 0,
      "channelLength": inp3,
      "channelTime": inp5,
      "channelStart": inp2,
      "channelOpcType": 1,
      "channelPlcId": 1,
      "companyId": ucer_id
    }

    console.log(obj);

    await Store.dispatch(add_channel(obj))

    const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/AddChannel", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json"
      },
      body: JSON.stringify(obj)
    })

    if (request.status === 200) {
      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_add");
      alert_box.classList.add("alert-box-active")
      Setalert(`${inp1} was added successfully`)

      setTimeout(() => {
        alert_box.classList.remove("alert_add")
        alert_box.classList.remove("alert-box-active")
        Setalert("")
      }, 4000);
    }





    var pop_up = document.querySelector(".add_channel_pop_up")
    var channel_seciton = document.querySelector("section.channel_section")
    if (channel_seciton.classList.contains("channel_section_dark")) channel_seciton.classList.remove("channel_section_dark")

    if (pop_up.classList.contains("add_channel_pop_up_active")) {
      pop_up.classList.remove("add_channel_pop_up_active")
    }

    Setinp1("")
    Setinp2(0)
    Setinp3(0)
    Setinp4(0)
    Setinp5(0)

  }


  return (
    <>
      <div className='' id="alert-box">{alert}</div>
      <div className="add_channel_pop_up">
        <header>Add New Channel</header>
        <form onSubmit={OnFormSubmit}>
          <div className="input-group">Name <input onChange={OnChangeinp1} value={inp1} type="text" placeholder='channel name' /></div>
          <div className="input-group">Start <input onChange={OnChangeinp2} value={inp2} type="number" placeholder='channel start' /></div>
          <div className="input-group">Length <input onChange={OnChangeinp3} value={inp3} type="number" placeholder='channel length' /></div>
          <div className="input-group">DB Number <input onChange={OnChangeinp4} value={inp4} type="number" placeholder='db number' /></div>
          <div className="input-group">Time <input onChange={OnChangeinp5} value={inp5} type="number" placeholder='channel time' /></div>
          <div className="input-group"> OPC Type
            <select id="add_new_channel_select_type">
              <ul style={{ display: "none" }}>
                <li>Uint</li>
                <li>String</li>
                <li>Double</li>
                <li>Bool</li>
                <li>Single</li>
              </ul>
            </select>
          </div>
          <div className="input-group">Type <select name="" id="add_new_channel_select_type">
            <ul style={{ display: "none" }}>
              <option value={"flag"}>Flag</option>
              <option value={"output"}>Output</option>
              <option value={"input"}>Input</option>
              <option value={"datablock"}>DataBlock</option>
            </ul></select></div>
          <div className="input-group">PLC <select id="add_new_channel_select_module">
            {props.plc.map((item, index) => {
              console.log(item);
              if (item.plc_active === "true") {
                return <option value={index}>{item.plc_name}</option>
              }
            })}
          </select></div>
          <div className="btn-group"><button type='button' onClick={close_add_pop_up}>Cancel <i class="fa-solid fa-ban"></i></button><button>Add <i class="fa-solid fa-check"></i></button></div>
        </form>
      </div>
      <div className="edit_channel_pop_up">
        <header>Edit PLC</header>
        <form onSubmit={onEditFormSubmit}>
          <div className="input-group">Name <input onChange={OnChangeinp1_1} value={edit_channel_name} type="text" placeholder='channel name' /></div>
          <div className="input-group">Start <input onChange={OnChangeinp2_2} value={edit_start} type="number" placeholder='channel start' /></div>
          <div className="input-group">Length <input onChange={OnChangeinp3_3} value={edit_channel_length} type="number" placeholder='channel length' /></div>
          <div className="input-group">DB Number <input onChange={OnChangeinp4_4} value={edit_channel_db_number} type="number" placeholder='db number' /></div>
          <div className="input-group">Time <input onChange={OnChangeinp5_5} value={edit_channel_time} type="number" placeholder='channel time' /></div>
          <div className="input-group"> OPC Type
            <select id="add_new_channel_select_type">
              <ul style={{ display: "none" }}>
                <li>Uint</li>
                <li>String</li>
                <li>Double</li>
                <li>Bool</li>
                <li>Single</li>
              </ul>
            </select>
          </div>
          <div className="input-group">Type <select name="" id="add_new_channel_select_type">
            <ul style={{ display: "none" }}>
              <li>Flag</li>
              <li>Output</li>
              <li>Input</li>
              <li>DataBlock</li>
            </ul>
          </select>
          </div>
          <div className="input-group">PLC <select id="add_new_channel_select_module">{props.plc.map((item, index) => {
            if (item.plc_active === "true") {
              return <option value={index}>{item.plc_name}</option>
            }
          })}</select></div>
          <div className="btn-group"><button type='button' onClick={close_edit_pop_up}>Cancel <i class="fa-solid fa-ban"></i></button><button >Update <i class="fa-solid fa-check"></i></button></div>
        </form>
      </div>
      <section className="channel_section">
        <h1><div onClick={open_add_pop_up}>New Channel <i className="fa fa-plus"></i></div>  </h1>
        <div className="table_channel_top">
          <div className="row">
            <span>Channel Name</span>
            <span>Start</span>
            <span>Length</span>
            <span>Time</span>
            <span>Type</span>
            <span>DB Number</span>
            <span>PLC Name</span>
            <span>OPC Type</span>
            <span style={{ opacity: "0" }}></span>
          </div>
          <div className="row">
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span></span>

          </div>
        </div>
        <div className="table_channel_bottom">
          {props.channels ? props.channels.map((item, index) => {
            return <div id={item.channelId} className="row">
              <span>{item.channelName}</span>
              <span>{item.channelStart}</span>
              <span>{item.channelLength}</span>
              <span>{item.channelTime}</span>
              <span>{item.channelType}</span>
              <span>{item.channelDbNumber}</span>
              <span>{item.PlcId}</span>
              <span>{item.OpcType}</span>
              <span className='edit_btns_channel'><button style={{ pointerEvents: !channel_yazma_control ? "none" : "all" }} disabled={!channel_yazma_control} onClick={open_edit_pop_up}>Edit</button><button style={{ pointerEvents: !channel_silme_control ? "none" : "all" }} disabled={!channel_silme_control} onClick={(e) => {
                deleteRow(e)
              }}>Delete</button></span>
            </div>
          }) : ""}
        </div>
      </section>
    </>
  )
}

const MapStateToProps = (state) => {
  return {
    channels: state.project_reducer.channels,
    plc: state.project_reducer.plc,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    userId: state.auth_reducer.user_id

  }
}

export default connect(MapStateToProps)(Channel)